export const realtimerAudiences = {
  hubStateUpdated: (expertId: string) => `ExpertHubStateUpdated-${expertId}`,
  notificationInserted: (expertId: string) => `ExpertNotificationInserted-${expertId}`,
  jobOrderApplicationStatusUpdated: (expertId: string) =>
    `ExpertJobOrderApplicationStatusUpdated-${expertId}`,
};
